var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-card",attrs:{"outlined":""}},[_c('v-subheader',[_vm._v("Links")]),_c('v-divider'),_c('px-lista-links',{attrs:{"links":_vm.links,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }